import React from 'react';

import svg from './assets/icons-24-visibility-off.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconVisibilityOff = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-visibility-on" />
);
